import React from 'react'
import OrangeVipStandardZero from '../components/dashboard/OrangeVipStandardZero'
import { apiService } from '../services/api'

const OrangeLocatorVipStandardZeroPage = () => (
  <OrangeVipStandardZero
    title="Orange — Lokalizator · VIP / Standard / Zero"
    subtitle="Klasyfikacja salonów Lokalizator po wolumenie sprzedaży."
    breadcrumb={['KAM-SFA', 'Orange', 'Lokalizator', 'VIP / Standard / Zero']}
    fetchData={apiService.getOrangeLocatorVipStandardZero}
    fetchExport={apiService.getOrangeLocatorVipStandardZeroExport}
    exportFilenamePrefix="VIP_Standard_Zero_Orange_Locator"
    showPolkoweFilter
  />
)

export default OrangeLocatorVipStandardZeroPage
